import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import tags from './modules/tags'
import user from './modules/user'
import select from './modules/select'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    app,
    tags,
    user,
    select
  }
})
